export const MY_ACCOUNT_TRANSLATION = 'my-account';

export enum FactorType {
  SMS = 'sms',
}

export const MOCK_FACTORS = [
  {
    factorType: FactorType.SMS,
    profile: {
      phoneNumber: '+111111111111',
    },
  },
];
